import anime from "animejs";

let animeId;
const setHandlers = (anchors, getOffset) => {
    anchors.map((a) => {
        a.dataset.jsAnchor = 'true';
        a.addEventListener('click', function (e) {
            e.preventDefault();

            const el = document.querySelector(this.hash);

            if (!el) return;

            const top = el.getBoundingClientRect().top + scrollY - getOffset();

            if (animeId) animeId.remove(document.documentElement);
            animeId = anime({
                targets: [document.documentElement],
                scrollTop: top,
                duration: 600,
                easing: 'easeInOutSine',
            });
        })
    });
}

export const initAnchors = (getOffset) => {
    const anchors = document.querySelectorAll('.js-anchor:not([data-js-anchor])');

    if (!anchors.length) return;

    setHandlers([...anchors], getOffset);
}

const mixin = {
    mounted() {
        const getOffset = () => this.$store?.getters?.['app/mainTopOffsetScrolled'];
        initAnchors(getOffset);
    },
}

export default {
    install(Vue) {
        Vue.mixin(mixin);
    }
};
